(function () {
	'use strict';

	angular.module('mx.components').directive('mxOnClickOutside', MxOnClickOutside);

	MxOnClickOutside.$inject = ['$window', '$parse'];
	function MxOnClickOutside($window, $parse) {
		return {
			link: function (scope, el, attr) {
				if (!attr.mxOnClickOutside) {
					return;
				}

				var nakedEl = el[0];
				var fn = $parse(attr.mxOnClickOutside);

				var handler = function (e) {
					// if Panel contains md-calendars or other md-dropdowns
					// then we should not close it while user select something from those extra-dropdown panels.
					var extraPanel = $('.md-pane-open:visible');
					var extraSelectPanel = $('.md-select-menu-container:visible');
					if (
						nakedEl === e.target ||
						nakedEl.contains(e.target) ||
						$(e.target).hasClass('md-scroll-mask') ||
						(extraPanel.length && extraPanel[0].contains(e.target)) ||
						(extraSelectPanel.length && extraSelectPanel[0].contains(e.target))
					) {
						return;
					}

					e.stopPropagation();
					scope.$apply(fn);
				};

				$window.addEventListener('mousedown', handler, true);

				scope.$on('$destroy', function () {
					$window.removeEventListener('mousedown', handler, true);
				});
			},
		};
	}
})();
